var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49198 38.5267V36.36C2.49198 30.3769 7.34223 25.5267 13.3253 25.5267H21.4503M26.3253 10.36C26.3253 15.1465 22.4451 19.0267 17.6586 19.0267C12.8722 19.0267 8.99198 15.1465 8.99198 10.36C8.99198 5.57356 12.8722 1.69336 17.6586 1.69336C22.4451 1.69336 26.3253 5.57356 26.3253 10.36Z",
    stroke: "#534682",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8574 26.1559L26.9564 39.057C26.6772 39.3363 26.3216 39.5266 25.9344 39.604L21.7405 40.4428L22.5793 36.2489C22.6567 35.8617 22.847 35.5061 23.1262 35.2269L36.0272 22.3257M39.8574 26.1559L42.0229 23.9904C42.4134 23.5999 42.4134 22.9667 42.0229 22.5762L39.6069 20.1602C39.2164 19.7697 38.5832 19.7697 38.1927 20.1602L36.0272 22.3257M39.8574 26.1559L36.0272 22.3257",
    stroke: "#534682",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseredit);
export default __webpack_public_path__ + "static/media/useredit.d4fae7f617e8dd2b3ab1b56c96e5339f.svg";
export { ForwardRef as ReactComponent };